import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const PrinterIcon = ({ color = '#0D84FE', size = '14', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color}>
      <path d="M29.188 7.563h-4.75V.938A.938.938 0 0 0 23.5 0h-15a.938.938 0 0 0-.938.938v6.625h-4.75A2.816 2.816 0 0 0 0 10.374V23.5c0 .518.42.938.938.938h6.625v6.625c0 .517.42.937.937.937h15c.518 0 .938-.42.938-.938v-6.625h6.625c.517 0 .937-.42.937-.937V10.375a2.816 2.816 0 0 0-2.813-2.813zM9.438 1.875h13.124v5.688H9.438V1.875zm13.124 28.25H9.438v-9.438h13.126v9.438zm1.875-10.375a.938.938 0 0 0-.937-.938h-15a.938.938 0 0 0-.938.938v2.813H5.688v-4.688a.94.94 0 0 1 .938-.938h18.75a.94.94 0 0 1 .938.938v4.688h-1.875V19.75zm5.688 2.813h-1.938v-4.688a2.816 2.816 0 0 0-2.812-2.813H6.625a2.816 2.816 0 0 0-2.813 2.813v4.688H1.875V10.374c0-.517.42-.938.938-.938h26.375a.94.94 0 0 1 .937.938v12.188z" />
      <path d="M19.75 26.313h-7.5a.938.938 0 0 0 0 1.875h7.5a.938.938 0 0 0 0-1.875zm0-3.75h-7.5a.938.938 0 0 0 0 1.875h7.5a.938.938 0 0 0 0-1.875z" />
      <circle cx="23.5" cy="12.25" r="1" />
      <circle cx="27.25" cy="12.25" r="1" />
    </g>
  </svg>
);

PrinterIcon.propTypes = propTypes;

export default PrinterIcon;
